"use strict";
/** Πίνακας εργασιών CRM — κοινό web & mobile */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TASK_BOARD_COLUMN_LABELS = exports.TASK_BOARD_COLUMNS = void 0;
exports.taskBoardColumn = taskBoardColumn;
exports.groupTasksByBoardColumn = groupTasksByBoardColumn;
exports.TASK_BOARD_COLUMNS = ['OPEN', 'DONE', 'CANCELLED'];
exports.TASK_BOARD_COLUMN_LABELS = {
    OPEN: 'Ανοιχτές',
    DONE: 'Ολοκληρωμένες',
    CANCELLED: 'Ακυρωμένες',
};
function taskBoardColumn(task) {
    if (task.status === 'OPEN' || task.status === 'DONE' || task.status === 'CANCELLED') {
        return task.status;
    }
    return null;
}
function groupTasksByBoardColumn(tasks) {
    const g = { OPEN: [], DONE: [], CANCELLED: [] };
    for (const task of tasks) {
        const col = taskBoardColumn(task);
        if (col)
            g[col].push(task);
    }
    g.OPEN.sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
    g.DONE.sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
    g.CANCELLED.sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
    return g;
}
